import { Box, Heading } from '@wix/design-system'
import React, { FC, memo } from 'react'

import { SuggestionItem } from './SuggestionItem'
import s from './Suggestions.scss'
import type { SuggestionContent } from './types'

type SuggestionsProps = {
  visible: boolean
  label: string
  items: SuggestionContent[]
  onItemClick: (text: string, index: number) => void
}

export const Suggestions: FC<SuggestionsProps> = memo(({ visible, label, items, onItemClick }) => (
  <Box
    direction="vertical"
    gap="SP1"
    align="left"
    marginLeft="SP4"
    marginTop="20px"
    visibility={visible ? 'visible' : 'hidden'}
  >
    <Box marginBottom="SP1">
      <Heading className={s.suggestionsLabel}>{label}</Heading>
    </Box>
    {items.map((suggestion, index) => (
      <SuggestionItem key={index} text={suggestion.text} index={index} onClick={onItemClick} />
    ))}
  </Box>
))
